import { ValidationRule, Message } from 'react-hook-form';

const requiredValidator = (
  message: string | boolean = 'validators.required'
): { required: Message | ValidationRule<boolean> } => ({
  required: message
});

export default requiredValidator;
